import { PlayOptions, sound as soundLibrary } from '@pixi/sound'
import { SweetBombSoundType } from '../enum/soundType'
import { soundManager, SoundType, useSpeedStore } from '@slot-nx/core'

export const playSound = (soundEnum: SweetBombSoundType | SoundType, options: PlayOptions) => {
  const sound = soundLibrary.find(soundEnum as string)
  if (!sound || sound.isPlaying) return
  soundManager.play(soundEnum, { ...options })
}

export const playStopSound = () => {
  const isSpeed = useSpeedStore.getState().isEnabled
  if (isSpeed) {
    soundManager.play(SweetBombSoundType.StopTurbo)
  }
  else {
    soundManager.play(SweetBombSoundType.Stop)
  }
}
